export const EQUITY_FOCUS_TITLE = 'EQUITY FOCUS';
export const FIXED_INCOME_FOCUS_TITLE = 'FIXED INCOME FOCUS';
export const DERIVATIVE_FOCUS_TITLE = 'DERIVATIVE FOCUS';
